import { ApiConfig } from "./apiConfig";

export const get_expense_head = async (data) => {
    try {
        const response = await ApiConfig.post(`expenseHeadList`,data && data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const get_expense_head_by_id = async (expense_head_id) => {
    try {
        const response = await ApiConfig.post(`showExpenseHead`,{expense_head_id});
        return response;
    } catch (error) {
        throw error;
    }
};


export const create_expense_head = async (data) => {
    try {
      const response = await ApiConfig.post(`createExpenseHead`,data);
      return response;
    } catch (error) {
      throw error;
    }
};

export const update_expense_head = async (data) => {
    try {
      const response = await ApiConfig.post(`updateExpenseHead`,data);
      return response;
    } catch (error) {
      throw error;
    }
};